export default __webpack_public_path__ + "static/media/arrow_up_history.76018fe2.svg";